import { render } from "./v-transactions-list.vue?vue&type=template&id=1b8150e4"
import script from "./v-transactions-list.vue?vue&type=script&lang=js"
export * from "./v-transactions-list.vue?vue&type=script&lang=js"

import exportComponent from "/builds/simplecrm/simplecrmfront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__